var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6715_8744",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5996 17.5996V2.40039H2.40039V17.5996H17.5996Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6715_8744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11V3.44844C3 3.20069 3.28899 3.00001 3.64537 3.00001H9.3733C9.63004 3.00001 9.87625 3.07082 10.058 3.19714L12.7167 5.04546C12.8982 5.17167 13 5.3428 13 5.52122V6.27401",
    stroke: "#C6CED7",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08656 13.1819V14.23C3.08656 14.5787 3.36937 14.8616 3.71812 14.8616H7.21966",
    stroke: "#C6CED7",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 3V5.38334C8.99999 5.72389 9.3681 6 9.8222 6H13",
    stroke: "#C6CED7",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73621 5H5",
    stroke: "#C6CED7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58852 6.5H5",
    stroke: "#C6CED7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58852 9.5H5",
    stroke: "#C6CED7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8H8.66183",
    stroke: "#C6CED7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1952 13.0457C14.1923 13.681 13.6767 14.195 13.0405 14.195C12.4029 14.195 11.8861 13.6782 11.8861 13.0407C11.8861 12.4032 12.4029 11.8863 13.0405 11.8863C13.2899 11.8863 13.5211 11.9657 13.7098 12.1M17.0812 13.6179V12.4634L15.7879 12.1555C15.7401 12.0072 15.6802 11.863 15.6089 11.7244L16.306 10.5917L15.4896 9.77533L14.3569 10.4724C14.2183 10.4011 14.0741 10.3412 13.9258 10.2934L13.6179 9.00002H12.4634L12.1554 10.2934C12.0071 10.3412 11.863 10.4011 11.7244 10.4724L10.5916 9.77533L9.7753 10.5917L10.4724 11.7244C10.401 11.863 10.3412 12.0072 10.2933 12.1555L8.99999 12.4634V13.6179L10.2933 13.9258C10.3412 14.0741 10.4011 14.2183 10.4724 14.3569L9.7753 15.4896L10.5916 16.306L11.7244 15.6089C11.8629 15.6802 12.0071 15.7401 12.1554 15.788L12.4634 17.0813H13.6179L13.9258 15.788C14.0741 15.7401 14.2183 15.6802 14.3569 15.6089L15.4896 16.306L16.306 15.4896L15.6089 14.3569C15.6802 14.2183 15.7401 14.0741 15.7879 13.9258L17.0812 13.6179Z",
    stroke: "#C6CED7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageFields);
export default __webpack_public_path__ + "static/media/manageFields.af420ea6831496f9a3dfcf08af1d80ee.svg";
export { ForwardRef as ReactComponent };